export enum ApiRoutesInventory {
  InventoryBox = "inventory-box-admin",
  CreateInventoryBox = "inventory-box-admin/draft",
  AllInventoryBoxesQrs = "inventory-box-admin/all-qr",
  InventoryBoxQr = "inventory-box-admin/one",

  InventoryManager = "admin/inventory-managers",
  AllInventoryManagers = "admin/inventory-managers/all",
  InventoryManagerActiveStatus = "admin/inventory-managers/active",
  Restore = "restore",

  AllDamagedItems = "box-item-admin/damaged/all",
  DamagedItem = "box-item-admin/damaged/one",
  AllMissingItems = "box-item-admin/lost/many"
}

export * from "./inventoryManagerStatuses";
